import type { CreatureArmorClassCompileInput, CreatureArmorClassCompileResult } from '../types';

function phpInt(value: number): number {
    return Number.isFinite(value) ? Math.trunc(value) : 0;
}

export const AC_DEFINITION_NOT_HELD = 'armorclass31:ac-definition-not-held';

/** Final arithmetic after armor resolution and Body capping. */
export function compileCreatureArmorClass(input: CreatureArmorClassCompileInput): CreatureArmorClassCompileResult {
    const maxBodyAcMod = phpInt(input.maxBodyAcMod);
    const totalAcMod = input.modifierValues.reduce((total, value) => total + phpInt(value), 0);
    const ec = 10 + maxBodyAcMod;
    const ac = ec + totalAcMod;
    return {
        max_body_ac_mod: maxBodyAcMod,
        total_ac_mod: totalAcMod,
        ec,
        ac,
        dr: ac - 10,
    };
}
